class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const KEY = 'target:recently-viewed';
    const current = this.dataset.currentHandle;
    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      handles = [];
    }
    // only valid Shopify handles may reach the fetch URL; injected markup is
    // always our own shop's server-rendered card-only section (same origin)
    handles = handles.filter((h) => typeof h === 'string' && /^[\p{L}\p{N}-]+$/u.test(h));

    if (current) {
      handles = [current, ...handles.filter((h) => h !== current)].slice(0, 12);
      try {
        localStorage.setItem(KEY, JSON.stringify(handles));
      } catch (e) {
        // storage full/blocked: still render from what we read
      }
    }

    const show = handles.filter((h) => h !== current).slice(0, Number(this.dataset.limit) || 4);
    if (show.length === 0) return;

    const grid = this.querySelector('.recently-viewed__grid');
    grid.innerHTML = show
      .map(() => '<li class="grid__item"><div class="recently-viewed__skeleton"></div></li>')
      .join('');
    this.hidden = false;

    Promise.all(
      show.map((handle) =>
        fetch(`${window.shopUrl}/products/${handle}?section_id=card-only`)
          .then((response) => (response.ok ? response.text() : ''))
          .catch(() => '')
      )
    ).then((cards) => {
      const items = cards.filter(Boolean);
      if (items.length === 0) {
        this.hidden = true;
        return;
      }
      grid.innerHTML = items.map((html) => `<li class="grid__item">${html}</li>`).join('');
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
